import { CameraImage } from "../cameras";
import { PanoControls } from "../controls";

export class CameraAlignerBasic {
  public enabled = false;
  private increment = 0.1;
  public cameraAngles = [0, 0, 0];
  private controls: PanoControls

  constructor(controls: PanoControls) {
    this.controls = controls;
    this.reset();
  }

  get currentCamera() : CameraImage {
    return this.controls.cameraHandler?.current;
  }

  setState(state) {
    this.enabled = state;
  }

  reset(values = [0,0,0]) {
    this.cameraAngles = [...values];
    this.updateAlignment();
  }

  onKeyDown(event) {
    if (!this.enabled) return false;

    let increment = event.altKey
      ? this.increment*10
      : this.increment;

    if (event.code === "Numpad7") {
      this.cameraAngles[0] -= increment;
    } else if (event.code === "Numpad9") {
      this.cameraAngles[0] += increment;
    } else if (event.code === "Numpad4") {
      this.cameraAngles[1] -= increment;
    } else if (event.code === "Numpad6") {
      this.cameraAngles[1] += increment;
    } else if (event.code === "Numpad1") {
      this.cameraAngles[2] -= increment;
    } else if (event.code === "Numpad3") {
      this.cameraAngles[2] += increment;
    } else {
      return;
    }

    this.updateAlignment();
  }

  updateAlignment() {
    this.currentCamera?.applyTempRotation(this.cameraAngles);
  }
}